'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuDivider;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * The MenuDivider are used for separate content inside the ButtonMenu.
 */


function MenuDivider(props) {
  var variant = props.variant,
      className = props.className,
      style = props.style;

  var getVariantClassNames = function getVariantClassNames() {
    if (variant === 'default') {
      return 'rainbow-divider';
    }

    return 'rainbow-divider_space';
  };

  var getClassNames = function getClassNames() {
    return (0, _classnames2.default)(getVariantClassNames(), className);
  };

  return _react2.default.createElement('li', {
    className: getClassNames(),
    style: style,
    role: 'separator'
  });
}

MenuDivider.propTypes = {
  /** The variant changes the margin of the divider. Valid values are default, and space.
  * This value defaults to default. */
  variant: _propTypes2.default.oneOf(['default', 'space']),

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2.default.string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes2.default.object
};
MenuDivider.defaultProps = {
  variant: 'default',
  className: undefined,
  style: undefined
};